package com.appcreator.shared

import androidx.compose.runtime.Composable
import com.appcreator.blueprint.components.CustomClientComponent
import com.appcreator.compose.di.Setup
import com.appcreator.compose.extensions.JSEvaluationConfig
import kotlinx.serialization.modules.subclass
import com.appcreator.compose.ResourcesLoader
import org.jetbrains.compose.resources.ExperimentalResourceApi
import com.appcreator.compose.BlueprintComposable
import com.appcreator.compose.BlueprintConfig
import com.appcreator.client.firebase.auth.FirebaseAuthInitializer
import com.appcreator.client.firebase.firestore.FirebaseFirestoreInitializer
import com.appcreator.client.firebase.storage.FirebaseStorageInitializer
import com.appcreator.client.firebase.appcheck.FirebaseAppCheckInitializer
import com.appcreator.client.firebase.messaging.FirebaseMessagingInitializer
import thedailycardioadmin.shared.generated.resources.Res
import thedailycardioadmin.shared.generated.resources.allFontResources

object AppCreatorSetup {

    @OptIn(ExperimentalResourceApi::class)
    fun initialize(
        developmentMode: Boolean,
        jsEvaluationConfig: JSEvaluationConfig
    ) {

        Setup.initialize(
            screenFetcher = { ResourcesLoader(it) { Res.readBytes(it) } },
            blueprintProvider = { ResourcesLoader(it) { Res.readBytes(it) } },
            componentFetcher = { ResourcesLoader(it) { Res.readBytes(it) } },
            jsEvaluationConfig = jsEvaluationConfig,
            developmentMode = developmentMode,
            apiToken = "",
            componentSerializers = {
                subclass(CustomClientComponent::class)

            },
            componentRegister = {

            }
        )

        platformInit()

        FirebaseAuthInitializer.initialize()
        FirebaseFirestoreInitializer.initialize()
        FirebaseStorageInitializer.initialize()
        FirebaseMessagingInitializer.initialize()
        if(BuildKonfig.recaptureId.isNotEmpty()) {
            FirebaseAppCheckInitializer.initialize(BuildKonfig.recaptureId)
        }
    }
}

expect fun platformInit()

@Composable
fun AppCreator() {
    BlueprintComposable(
        drawableResource = {
            try {
                Res.getUri(it)
            } catch (ex: Exception) {
                null
            }
        },
        fontResources = Res.allFontResources,
        config = BlueprintConfig(iosAppStoreAppId = "{iosAppStoreAppId}")
    )
}
